import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { RolesActions, RolesActionTypes } from './roles.actions';
import { IUserRole } from '@account-users/user/models/UserRole';

export const USER_ROLES_FEATURE_KEY = 'user-roles';

export interface UserRolesState extends EntityState<IUserRole> {
  userRoles: IUserRole[];
  isLoadingRoles: boolean;
}

const adapter: EntityAdapter<any> = createEntityAdapter<IUserRole>({
  selectId: (role) => role.code,
});

export const initialState: UserRolesState = {
  ids: [],
  entities: {},
  userRoles: [],
  isLoadingRoles: false,
};

export function reducer(
  state: UserRolesState = initialState,
  action: RolesActions,
): UserRolesState {
  switch (action.type) {
    case RolesActionTypes.LoadRolesSuccess: {
      return adapter.setAll(action.payload, {
        ...state,
        userRoles: action.payload,
        isLoadingPermissions: false,
      });
    }
    default:
      return state;
  }
}

const { selectEntities } = adapter.getSelectors();

export const getAllUserRoles = selectEntities;
